import currentUserStorage from 'containers/services/security/current-user-storage';
import { get, isEmpty, isNil } from 'lodash';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { VictimType, TransactionType } from 'typings/globalTypes';

export const formatExpertReport = (
  expertJudiciaryExpertise: any,
  victim: VictimType,
) => {
  const formatted = expertJudiciaryExpertise.map((el: any) => {
    return {
      ...el,
      expertiseJudgementAddDocumentId: null,
      vehicules: [],
      expertiseId: get(
        el.victimExpertises.find((it: any) => it.victimId === victim.id),
        'expertiseId',
      ),
      victims: [
        {
          ...victim,
          victimExpertise: {
            ...el.victimExpertises.find(
              (item: any) => item.victimId === victim.id,
            ),
          },
        },
      ],
    };
  });
  return formatted;
};
export const formatImportReport = (
  judiciaryExpertisesVictim: any,
  checked: any,
  transactionId: number,
  expertJudiciaryExpertise: any,
  transactionInfo: TransactionType,
  claimId: number,
) => {
  const judiciaryReport = get(
    expertJudiciaryExpertise.find(
      (y: any) =>
        !isEmpty(
          y.victims.find(
            (el: any) => el?.victimExpertise?.id === Number(checked),
          ),
        ),
    ),
    'victims.[0]',
    {},
  );

  const consultingReport = judiciaryExpertisesVictim.find(
    (el: any) => el.id === Number(checked),
  );
  if (
    !isEmpty(judiciaryExpertisesVictim) &&
    !isNil(get(consultingReport, 'missionId', null))
  ) {
    return {
      missionId: get(
        judiciaryExpertisesVictim.find((el: any) => el.id === Number(checked)),
        'missionId',
      ),
      claimId: claimId,
      missionExpertiseId: Number(checked),
      transactionId: transactionId,
      isTransactionInboxesActive: featureService.hasFeature(
        FEATURES.INBOXES_TRANSACTION_MANAGER,
      ),
      isTrackingActive: featureService.hasFeature(
        FEATURES.TRACKING_ACTIONS_USER,
      ),
    };
  } else if (
    !isEmpty(expertJudiciaryExpertise) &&
    !isEmpty(get(judiciaryReport, 'victimExpertise', {}))
  ) {
    return {
      victimId: get(judiciaryReport.victimExpertise, 'victimId'),
      transactionId: transactionId,
      claimId: get(judiciaryReport, 'claimId'),
      createdBy: currentUserStorage?.get()?.username,
      expertiseId: get(judiciaryReport.victimExpertise, 'expertiseId'),
      victimExpertiseId: get(judiciaryReport.victimExpertise, 'id'),
      isTransactionInboxesActive: featureService.hasFeature(
        FEATURES.INBOXES_TRANSACTION_MANAGER,
      ),
      isTrackingActive: featureService.hasFeature(
        FEATURES.TRACKING_ACTIONS_USER,
      ),
      victimExpertise: {
        ...judiciaryReport.victimExpertise,
        victimExpertiseDocument: {
          ...get(
            judiciaryReport,
            'victimExpertise.victimExpertiseDocuments.[0]',
            {},
          ),
        },
      },
    };
  }
};

export const isNilOrEmptyValue = (value: string) => {
  return isNil(value) || isEmpty(value);
};
